import { toCamelCaseProperties } from '@/utils/fn';

export default class Product {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};
		this.appointmentId = args.appointmentId;
		this.appointmentSalesLineId = args.appointmentSalesLineId;
		this.amount = args.amount || 0;
		this.campaignId = args.campaignId || 0;
		this.employeeId = args.employeeId || '';
		this.employeeInitials = args.employeeInitials || '';
		this.employeeImageUrl = args.employeeImageUrl || '';
		this.employeeName = args.employeeName || args.employeeFirstName || '';
		this.pricePerProduct = args.pricePerProduct || args.itemPrice || 0;
		this.productName = args.productName || args.itemName || '';
		this.saleBonuspointsEarned = args.saleBonuspointsEarned || args.bonusPointsEarned || 0;
		this.saleBonuspointsUsed = args.saleBonuspointsUsed || args.bonusPointsUsed || 0;
		this.vareId = args.vareId || args.treatmentOrProductId || args.productId || '';
		this.discounts = args.discounts || [];
	}
}
